import { CgSearch, CgChevronDown } from 'react-icons/cg';
import './style.scss';
import { categories } from 'types/realization';

interface Options {
    hideTextFilter?: boolean;
    enableCategoryFilter?: boolean;
    enablePrefixFilter?: boolean;
    placeholderField?: string;
    placeholderPrefixField?: string;
    categories?: categories[];
    onChange: (field: string, value: string) => void;
    inEnd?: boolean;
}

const Filter = ({ hideTextFilter, enableCategoryFilter, enablePrefixFilter, placeholderField, placeholderPrefixField, categories, onChange, inEnd }: Options) => {
    const changeValue = (field: string, value: string) => {
        onChange(field, value);
    };

    return (
        <div className="flex justify-center w-full mb-8 md:justify-end md:mb-12 filter">
            <div className={`w-[90%] ${inEnd ? 'md:w-[25%]' : 'md:w-[55%]'}`}>
                <div className="flex flex-col gap-8 md:flex-row">
                    {enableCategoryFilter && (
                        <div className="relative flex items-center flex-1 field field-select">
                            <select className="w-full bg-none px-[9px] py-[9px] appearance-none" onChange={(e) => changeValue('category', e.target.value)}>
                                {categories?.map((item, index: number) => (
                                    <option key={index} value={item._id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            <div className="absolute pointer-events-none right-2">
                                <CgChevronDown />
                            </div>
                        </div>
                    )}
                    {!hideTextFilter && (
                        <div className="flex-1 field">
                            <div className="relative w-full search-field">
                                <div className="absolute icon">
                                    <CgSearch />
                                </div>
                                <input type="search" className="w-full" placeholder={placeholderField || 'O que você procura?'} onChange={(e) => changeValue('searchTerm', e.target.value)} />
                            </div>
                        </div>
                    )}
                    {enablePrefixFilter && (
                        <div className="flex-1 field">
                            <div className="relative w-full search-field">
                                <div className="absolute icon">
                                    <CgSearch />
                                </div>
                                <input type="search" className="w-full" placeholder={placeholderPrefixField || 'Buscar por prefixo'} onChange={(e) => changeValue('prefix', e.target.value)} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Filter;
